const integrationTypeToIntegrationTypeObject = (response) => {
    return {
        id: response.id,
        name: response.name,
        createdAt: response.created_at,
        integrationProvider: response.integration_provider,
        integrationConnectionType: response.integration_connection_type,
        integrationPlatform: response.integration_platform,
        assetsPath: response.assets_path,
        integrationProviderConnectionId: response.integration_provider_connection_id
    };
};

export { integrationTypeToIntegrationTypeObject };
